import React, { useState , useEffect} from 'react'
import axios from 'axios'
import { useHistory } from 'react-router-dom'
import Header from './header';
import Footer from './footer';
import './style/users.css';

function MyBooking() {

  let history = useHistory()

  const [email, setEmail] = useState("");
  const [msg, setMessage] = useState("");
  const [msg2, setMessage2] = useState("");
  const [msg1, setMessage1] = useState("");
  // const [status, setStatus] = useState(false);

  if(false)
    {
      //did this to remove warnings
        setEmail(email);
    }

  const [list, setList] = useState([]);
    useEffect(()=> {
        axios.get('https://akshatngupta-bike-rental.herokuapp.com/booking/search/' + sessionStorage.getItem('email'))
      .then(response => {
        // 
        // if(response.data[0]==0)
        // setMessage("NO USERS PRESENT");
        setList(response.data);
      })
      .catch((error) => {
        console.log(error);
        if(error.response.status===404)
          setList([]);
        setMessage2('NO BOOKINGS EXISTS FOR THIS USER') 
        setMessage1(' TO MAKE BOOKING GO TO BOOKINGS PAGE')
      })
    })

    const handleClick = event => {
      event.preventDefault();
      let values = event.target.dataset.mssg.split("_")
      if(values[1] === "Update"){
        sessionStorage.setItem('email',values[0])
        history.push(`/updatebooking/${values[0]}`
        )
        setMessage('SUCCESSFULLY UPDATED')
      }
      else{
        let email = values[0]
        axios.delete('http://localhost:4500/booking/remove/' + email)
        .then(res => {
          console.log(res.data)
          setMessage('SUCCESSFULLY DELETED')
        })
        .catch(err => {
          console.log(err)
          setMessage('INVALID USER ID')
        })
      }
      setEmail('')
    }
    return (
      <div>
      <Header />
      <div>
        <form className="shift">
        <table className="table table-adminUser">
          <thead className="thead-dark"> 
            <tr>
              <th>PickUp Date</th>
              <th>PickUp Time</th>
              <th>Drop Date</th>
              <th>Drop Time</th>
              <th>Rent</th>
              <th>Action</th>
            </tr>
          </thead>
          {list.map((currentrow,idx) => {
            return (<tr key={idx}>
              <td>{currentrow.sdate}</td>
              <td>{currentrow.stime}</td>
              <td>{currentrow.edate}</td>
              <td>{currentrow.etime}</td>
              <td>{currentrow.rent}</td>
              <td id="search">
                <button type="button" id="search" data-mssg={`${currentrow.email}_Update`}  onClick={handleClick} class="btn btn-primary btn-others">Update</button>
                <button type="button" id="search" data-mssg={`${currentrow.email}_Delete`} onClick={handleClick} class="btn btn-danger btn-others">Delete</button>
              </td>
            </tr>
            )})}
        </table>
        </form>
      </div> 
      <div>
      <b style={{ color: "red" }}>{msg}</b>
      </div>
      <div>
      <b style={{ color: "red" }}>{msg2}</b>
      </div>
      <div>
      <b style={{ color: "red" }}>{msg1}</b>
      </div>
      <Footer />
      </div>
)}
export default MyBooking
